import { render } from "./TransactionBacklogView.vue?vue&type=template&id=a2e9137a"
import script from "./TransactionBacklogView.vue?vue&type=script&lang=js"
export * from "./TransactionBacklogView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__